import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '../constants';
import { ApiResponse, PaginatedResponse } from '../types';

export interface ReportItem {
  id: string;
  name: string;
  createdAt: string;
  status: 'queued' | 'processing' | 'completed' | 'failed';
}

export const reportsService = {
  async list(): Promise<PaginatedResponse<ReportItem>> {
    return apiClient.get<PaginatedResponse<ReportItem>>(API_ENDPOINTS.REPORTS.LIST, { authenticate: true });
  },

  async generate(payload: Record<string, unknown>): Promise<ReportItem> {
    const result = await apiClient.post<ApiResponse<ReportItem>>(API_ENDPOINTS.REPORTS.GENERATE, payload, {
      authenticate: true,
    });
    return result.data ?? (result as unknown as ReportItem);
  },

  async download(id: string): Promise<Blob> {
    const url = API_ENDPOINTS.REPORTS.DOWNLOAD(id);
    const response = await fetch(url, { headers: { Authorization: `Bearer ${localStorage.getItem('agentic_auth_token')}` } });
    return await response.blob();
  },
};


